import { BimContractStatusEnum } from 'gql/graphql';

import { useMemo } from 'react';

export enum MayBeDisabledByStatusKeys {
    constructionTypes = 'constructionTypes',
    seasonsRange = 'seasonsRange',
    generalInfoSubject = 'generalInfo.subject',
    generalInfoInternalNumber = 'generalInfo.internalNumber',
    generalInfoCustomerAddress = 'generalInfo.customerAddress',
    generalInfoContractor = 'generalInfo.contractor',
    generalInfoContractorAddress = 'generalInfo.contractorAddress',
    generalInfoSigningDate = 'generalInfo.signingDate',
    generalInfoStartDate = 'generalInfo.startDate',
    generalInfoFinishDate = 'generalInfo.finishDate',
    generalInfoAmountWithoutTax = 'cost.contractPlan',
    generalInfoNote = 'generalInfo.note',
    supplyBasis = 'supplyBasis',
    conversionIndices = 'conversionIndices',
    seasonsInflation = 'seasonsInflation',
    priceForm = 'priceForm',
}

export type TDisabledByStatusMap = Record<MayBeDisabledByStatusKeys, boolean>;

export const useIsDisabledByStatus = (status?: BimContractStatusEnum): TDisabledByStatusMap =>
    useMemo(() => {
        const isDisabled = [BimContractStatusEnum.Delayed, BimContractStatusEnum.Completed].includes(
            status as BimContractStatusEnum,
        );

        return Object.values(MayBeDisabledByStatusKeys).reduce(
            (acc, key) => ({ ...acc, [key]: isDisabled }),
            {} as TDisabledByStatusMap,
        );
    }, [status]);
